import * as React from 'react';

// tslint:disable:max-line-length
export const AppleBlack = () => (
  <div
    style={{
      width: 150,
      height: 50,
      background: `url('${require('./medias/apple_black.svg')}')`,
      backgroundSize: '100% 100%'
    }}
  />
);



// WEBPACK FOOTER //
// src/app/src/components/Badges/AppleBlack.tsx